import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { routerActions } from 'react-router-redux'
import * as R from 'ramda'
import { sort, sortSev, getByType, beautifyPhone } from 'utils/stuff'
import LeftNav from 'material-ui/Drawer'
import Colors from 'material-ui/styles/colors'
import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Divider from 'material-ui/Divider'
import {List, ListItem} from 'material-ui/List'
import repairman from 'selectors/repairman'
import { properties, managers } from 'selectors/entities'
import agents from 'selectors/agent'
import LeftNavMenu from 'components/LeftNavMenu'
import dataActions from 'actions/dataActions'
import newCommentActions from 'actions/newCommentActions'
import AttachmentRender from 'components/AttachmentRender'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import rightStackActions from 'actions/rightStackActions'
import actionBarActions from 'actions/actionbar'
import Error from 'components/Error'
import Deleted from 'components/Deleted'
import StarsRating from 'components/StarsRating'
import EntityAttachments from 'components/EntityAttachments'
import GeneralBlock from './GeneralBlock'
import ContactsBlock from './ContactsBlock'
import Checkbox from 'material-ui/Checkbox'
import {Tabs, Tab} from 'material-ui/Tabs'
import InputPhone from 'components/InputPhone'
import InputWeb from 'components/InputWeb'
import Geolocation from 'components/drivers/Geolocation'
import Comments from 'components/Comments'
import Attachments from 'components/Attachments'
import { attachmentPath } from 'selectors/attachments'

let select = (state, props) => ({
	...state
  ,  repairmen: repairman(state)
  ,  managers: getByType(state, 'manager')
  , path: attachmentPath(state, props.id || props.routeParams.id)
})

const tabStyle ={
	width: "33%",
	display: "table",
	textAlign: "center",
	float: "left",
	marginTop: "10px"
}

const tabHrefStyle = {
	color: "#FFFFFF",
	textDecoration: "none"
}
const categories = [
	"Carpet Installation"
  , "Carpeting"
  , "Chimney Sweeps"
  , "Contractors"
  , "Damage Restoration"
  , "Drywall Installation & Repair"
  , "Electricians"
  , "Fences & Gates"
  , "Fireplace Services"
  , "Flooring"
  , "Garage Door Services"
  , "Gardeners"
  , "Gutter Services"
  , "Handyman"
  , "Heating & Air Conditioning/HVAC"
  , "Home Cleaning"
  , "Home Inspectors"
  , "Keys & Locksmiths"
  , "Landscaping"
  , "Movers"
  , "Painters"
  , "Plumbing"
  , "Pool Cleaners"
  , "Roofing"
  , "Stucco Services"
  , "Tiling"
  , "Tree Services"
  , "Water Heater Installation/Repair"
  , "Window Washing"
]

export class Repairman extends Component{
	constructor(props){
		super(props)
		let repairmanID = props.id || props.routeParams.id
		this.state ={
			phoneNumber: {
				value: (props.repairmen[repairmanID])? props.repairmen[repairmanID].phoneNumber : undefined
			  , selectionStart: undefined
			}
		  , cellNumber: {
				value: (props.repairmen[repairmanID])? props.repairmen[repairmanID].cellNumber : undefined
			  , selectionStart: undefined
			}
		  , editing: ""
		  , completed: false
		  , expandedContacts: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? false : true
		  , expandedCategories: false
		}
	}
	componentWillUpdate(){
		let repairmanID = this.props.id || this.props.routeParams.id
		if(this.props.repairmen[repairmanID] && (typeof this.state.phoneNumber.value != "string" || typeof this.state.cellNumber.value != "string")){
			this.setState({
				phoneNumber: {
					value: this.props.repairmen[repairmanID].phoneNumber
				  , selectionStart: this.props.repairmen[repairmanID].phoneNumber.length
				}
			  , cellNumber: {
					value: this.props.repairmen[repairmanID].cellNumber
				  , selectionStart: this.props.repairmen[repairmanID].cellNumber.length
				}
			})
		}
	}
	render(){
		try {
			let repairmanID = this.props.id || this.props.routeParams.id
			let isMob = typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight)

			return(
				<div>
				{
				this.props.repairmen[repairmanID] && (!this.props.repairmen[repairmanID].cors || !Object.keys(this.props.repairmen[repairmanID].cors).length) && this.props.repairmen[repairmanID].address && <Geolocation
					address={this.props.repairmen[repairmanID].address}
					onSuccess={(cors) => this.props.DOC_UPDATE({_id: repairmanID, cors: (JSON.parse(cors).results.length) ? JSON.parse(cors).results[0].geometry.location : {}})}
					/>
				}

				{
				(this.state.editing == "general" && (typeof global.md.phone() == 'string' || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight)))?
					<GeneralBlock
						repairman = {this.props.repairmen[repairmanID]}
						setState = {(val) => this.setState({editing: val})}
						docUpd = {this.props.DOC_UPDATE}
						login={this.props.session}
					/>
				: (this.state.editing == "contacts" && (typeof global.md.phone() == 'string' || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight)))?
					<ContactsBlock
						repairman = {this.props.repairmen[repairmanID]}
						setState = {(val) => this.setState({editing: val})}
						docUpd = {this.props.DOC_UPDATE}
						login={this.props.session}
					/>
				:<div style={{...this.props.style, height: "auto"}}>
					<header
						style={{
							width: "100%"
						  , height: "60px"
						  , top: "0"
						  , zIndex: "5555"
						  , backgroundColor: "#00ACC1"
						  , position: "fixed"
						  , lineHeight: "60px"
						  , paddingTop: "0"
						  , borderBottom: "1px solid #e1e3e2"
						}}
						className="action-bar form-holder"
					>
							{(typeof global.md.phone() == 'string')?
								<div
									style={{
										width: "inherit"
									  , height: "inherit"
									}}
								>
									<img
										src="/static/img/hamburger.png"
										style={{
											maxHeight: "20%"
										  , verticalAlign: "middle"
										  , marginLeft: "21px"
										}}
										onTouchTap={this.props.TOOGLE_LEFT_NAV}
									/>
									<span
										style={{
											overflow: "hidden"
										  , textOverflow: "ellipsis"
										  , whiteSpace: "nowrap"
										  , display: "inline-block"
										  , width: "50%"
										  , verticalAlign: "middle"
										  , marginLeft: "8%"
										}}
									>
										{(this.props.repairmen[repairmanID])? this.props.repairmen[repairmanID].firstName : ""}
									</span>
									<div
										style={{
											float: "right"
										  , width: "15%"
										  , textAlign: "right"
										  , height: "inherit"
										}}
									>
										<img
											src="/static/img/trash.png"
											style={{
												maxHeight: "40%"
											  , verticalAlign: "middle"
											  , marginRight: "21px"
											}}
											onClick={()=> {
												this.props.DOC_DELETE(repairmanID)
												this.props.goBack()
											}}
										/>
									</div>
								</div>
								:
									<div id="close-project-specs"
										style={{
											lineHeight: "60px"
										  , marginLeft: "12px"
										  , marginTop: "-1px"
										}}
									>
										<svg
											width="17px"
											height="17px"
											viewBox="0 0 17 17"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											style={{
												verticalAlign: "middle"
											  , marginLeft: "12px"
											  , cursor: "pointer"
											}}
											onClick={()=>{
												this.props.goBack()
											}}
										>
										    <title>Group</title>
										    <defs></defs>
										    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
										        <g id="Group" transform="translate(1.000000, 1.000000)" stroke="#FFF" strokeWidth="2">
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
										        </g>
										    </g>
										</svg>
										<span
											style={{
												fontSize: "24px"
											  , marginTop: "0px"
											  , marginLeft: "20px"
											  , verticalAlign: 'middle'
											  , display: "inline-block"
											  , width: "calc(100% - 29px - 50px)"
											  , textAlign: "left"
											}}
										>
											{(this.props.repairmen[repairmanID])? this.props.repairmen[repairmanID].firstName: ""}
										</span>
										{(this.props.repairmen[repairmanID])?
											<svg
												width="18px"
												height="21px"
												viewBox="0 0 49 59"
												version="1.1"
												xmlns="http://www.w3.org/2000/svg"
												xmlnsXlink="http://www.w3.org/1999/xlink"
												style={{
													verticalAlign: "middle"
												  , cursor: "pointer"
												  , marginLeft: "7px"
												  , position: "relative"
												  , left: "-16px"
												}}
												onClick={() => {
													document.getElementsByClassName('Prompt')[0].style.marginLeft = 0
												}}
											>
											    <title>delete</title>
											    <defs></defs>
											    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											        <g id="delete" fill="#FFF">
											            <g id="Group">
											                <path d="M24.5,51 C25.052,51 25.5,50.553 25.5,50 L25.5,17 C25.5,16.447 25.052,16 24.5,16 C23.948,16 23.5,16.447 23.5,17 L23.5,50 C23.5,50.553 23.948,51 24.5,51 L24.5,51 Z" id="Shape"></path>
											                <path d="M14.5,51 C15.052,51 15.5,50.553 15.5,50 L15.5,17 C15.5,16.447 15.052,16 14.5,16 C13.948,16 13.5,16.447 13.5,17 L13.5,50 C13.5,50.553 13.948,51 14.5,51 L14.5,51 Z" id="Shape"></path>
											                <path d="M34.5,51 C35.052,51 35.5,50.553 35.5,50 L35.5,17 C35.5,16.447 35.052,16 34.5,16 C33.948,16 33.5,16.447 33.5,17 L33.5,50 C33.5,50.553 33.948,51 34.5,51 L34.5,51 Z" id="Shape"></path>
											                <path d="M47.5,6 L33.456,6 C33.346,4.75 32.961,2.642 31.643,1.289 C30.809,0.434 29.751,0 28.499,0 L18.5,0 C17.248,0 16.19,0.434 15.356,1.289 C14.038,2.642 13.653,4.75 13.543,6 L1.5,6 C0.948,6 0.5,6.447 0.5,7 C0.5,7.553 0.948,8 1.5,8 L3.541,8 L5.456,54.021 C5.493,55.743 6.565,59 10.364,59 L38.636,59 C42.435,59 43.507,55.743 43.543,54.042 L45.459,8 L47.5,8 C48.052,8 48.5,7.553 48.5,7 C48.5,6.447 48.052,6 47.5,6 L47.5,6 Z M16.792,2.681 C17.24,2.223 17.799,2 18.5,2 L28.499,2 C29.2,2 29.759,2.223 30.207,2.681 C31.012,3.504 31.335,4.952 31.447,6 L15.553,6 C15.665,4.952 15.988,3.504 16.792,2.681 L16.792,2.681 Z M41.544,53.979 C41.538,54.288 41.4,57 38.636,57 L10.364,57 C7.63,57 7.466,54.283 7.455,53.958 L5.542,8 L43.457,8 L41.544,53.979 L41.544,53.979 Z" id="Shape"></path>
											            </g>
											        </g>
											    </g>
											</svg>
										: ''
										}
									</div>
							}
  	  					{(this.props.repairmen[repairmanID])?
				  			<div
				  				style={{
				  					marginLeft: "100%"
				  				  , position: 'absolute'
				  				  , top: '10px'
				  				  , background: 'rgba(0,0,0,0.8)'
				  				  , padding: '11px'
				  				  , transition: 'all ease-in-out 0.3s'
				  				  , width: '100%'
				  				}}
				  				className="Prompt"
				  			>
				  				<span style={{verticalAlign: 'middle'}}>
				  					Are you sure you want to delete this item?
				  				</span>
				  				<div style={{float: "right", position:"relative", top:"-5px"}}>
				  					<FlatButton
				  						label="Yes"
				  						primary={true}
				  						onClick={()=> {
											this.props.DOC_DELETE(repairmanID)
											this.props.goBack()
										}}
				  					/>
				  					<FlatButton
				  						label="No"
				  						secondary={true}
				  						onClick={() => {
				  							document.getElementsByClassName('Prompt')[0].style.marginLeft = "100%"
				  						}}
				  					/>
				  				</div>
				  			</div>
							:''
						}
					</header>
					{(!this.props.repairmen[repairmanID])?
							<Deleted />
						:
						<Tabs
							inkBarStyle={{backgroundColor: "#23987c"}}
							tabItemContainerStyle={{backgroundColor: "#3cd2ae", height: "48px"}}
							style={{
								marginTop: "60px"
							}}
							initialSelectedIndex={(this.props.routing.locationBeforeTransitions.query.comments)? 1 : 0}
						>
							<Tab
								label={<span>GENERAL</span>}
							>

							<div
								style={{
										maxWidth: (this.props.id)? 'auto' : '800px'
									  , margin: "auto"
									  , overflowY: "auto"
									  , overflowX: "hidden"
									  , height: (isMob)? "calc(100vh - 108px)" : "calc(100vh - 108px)"
									  , paddingTop: (isMob)?"0px":"16px"
									  , paddingLeft: (isMob)?"0px":"44px"
								}}
								speed={0.8}
					            className="area"
					            contentClassName="content"
					            horizontal={false}
								verticalScrollbarStyle={{
									width: "16px"
								  , borderRadius: "13px"
								  , marginLeft: "1px"
								  , backgroundImage: "url(/static/img/bar.png)"
								  , backgroundSize: "100%"
								  , backgroundRepeat: "no-repeat"
								  , backgroundColor: "#f5f6f5"
								  , backgroundPosition: "center"
								  , display: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" :"auto"
								}}
								minScrollSize={30}
								verticalContainerStyle={{
									width: "18px"
								  , backgroundColor: "#cdcdcd"
								  , opacity: "1"
								  , display: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" :"auto"
								}}
								ref="right-panel"
								className={(typeof global.md.phone() == 'string')? "mobile-right-panel": ""}
							>
								<div
									className="general-info logical-block"
									style={{
										paddingBottom: "22px"
									}}
								>
									{
										(this.state.editing == "general")?
												<img src="/manager/static/img/ok.png"
													style={{
														 float: "right"
													  , height: "20px"
													  , lineHeight: "35px"
													  , cursor: "pointer"
													}}
													onClick={()=> this.setState({editing: "none"})}
												/>
											:
												<img
													src="../static/img/pencil-edit.png"
													style={{
														float: "right"
													  , height: "20px"
													  , margin: "0"
													  , cursor: "pointer"
													}}
													onClick={()=> this.setState({editing: "general"})}
												/>
									}
									<div style={{marginTop: "10px", marginLeft:"0px", paddingRight: "20px"}}>
										<div
											style={{
												display: (this.state.editing == "general")? "block" : "inline-block"
											}}
										>
											<p
												style={{
													fontSize: "9pt"
												  , fontWeight: "100"
												  , color: "#909090"
												  , margin: "0"
												}}
											>
												Name & rating
											</p>
											{
												(this.state.editing == "general")?
														<TextField
															defaultValue={this.props.repairmen[repairmanID].firstName}
															errorText={(this.props.repairmen[repairmanID]&&this.props.repairmen[repairmanID].firstName)?"":"This field is required"}
															onBlur={(evt) =>
																this.props.DOC_UPDATE({
																	_id: repairmanID
																  , firstName: evt.target.value
																})
															}
															style={{
																width: "calc(100% - 125px)"
															  , display: "block"
															}}
														/>
													:
														<p
															style={{
																fontWeight: "100"
															  , marginBottom: "0"
															  , marginTop: "7px"
															}}
														>
															{(this.props.repairmen[repairmanID]&&this.props.repairmen[repairmanID].firstName)?this.props.repairmen[repairmanID].firstName:<span style={{color: "#FF0000"}}>Name is requierd</span>}
														</p>
											}
										</div>
										<br/>
										<StarsRating
											style={{
												marginLeft: "0px"
											  , display: "inline-block"
											  , verticalAlign: "middle"
											  , position: "relative"
											  , marginTop: (this.state.editing == "general"&&this.props.repairmen[repairmanID].firstName)?"-20px":"0px"
											}}
											key={(this.state.editing == "general")? "edit" : "normal"}
											value = {(this.props.repairmen[repairmanID].rating)?this.props.repairmen[repairmanID].rating:"0"}
											size={(this.state.editing == "general")? "35" : "17"}
											clickable = {this.state.editing == "general"}
											className={(typeof global.md.phone() == 'string')? "company-rating" : ""}
											onChange = {(value) =>
												this.props.DOC_UPDATE({
													_id: repairmanID
												  , rating: value
												  , comments: (!this.props.repairmen[repairmanID].comments)?
														[{
															userID: this.props.session.userID
														  , auto: true, body: 'Change rating'
														  , date: new Date().valueOf()
														  , value: value
														}]
														: [
															...this.props.repairmen[repairmanID].comments
														  , {
																userID: this.props.session.userID
															  , auto: true, body: 'Change rating'
															  , date: new Date().valueOf()
															  , value: value
															}
														]
												})
											}
										/>

										{(this.state.editing == "general")?
											<div
												className={`DropDownMenu ${(this.state.expandedCategories)? 'expand' : 'hidden'}`}
												onClick={()=> this.setState({expandedCategories: !this.state.expandedCategories})}
												key="expander"
												style={{marginTop: "32px"}}
											>
												<div
													className="categories-inline"
												>
													{this.props.repairmen[repairmanID].categories ?
														R.values(
															R.mapObjIndexed((category, indx) => (
																	<span key={indx} style={{marginRight: '5px'}}>
																		{category}
																		{(this.props.repairmen[repairmanID].categories.length - 1 == indx)? ".": ", "}
																	</span>
															), this.props.repairmen[repairmanID].categories)
														)
														:
														''}
												</div>
												<div
													className="service"
												>
													<span className="count">
														+ {this.props.repairmen[repairmanID].categories.length} categories
													</span>
													<i
														className="material-icons"
													>
														{(this.state.expandedCategories)? "keyboard_arrow_up" : "keyboard_arrow_down"}
													</i>
												</div>
												<div
													className="categories-list"
												>
													{
														R.map(category => (
															<div className="listitem">
																<Checkbox
																	checked={~this.props.repairmen[repairmanID].categories.indexOf(category)}
																	label={category}
																	iconStyle={{
																		width: "15px"
																	  , height: "15px"
																	  , marginTop: "1px"
																	  , marginRight: "10px"
																	}}
																	style={{
																		height: "30px"
																	  , fontSize: "14px"
																	  , verticalAlign: "middle"
																	}}
																	onCheck={(evt) => {
																		(~this.props.repairmen[repairmanID].categories.indexOf(category))?
																			this.props.DOC_UPDATE({
																				_id: repairmanID
																			  , categories: R.reject(categ => categ == category, this.props.repairmen[repairmanID].categories)
																			})
																			: this.props.DOC_UPDATE({
																				_id: repairmanID
																			  , categories: [...this.props.repairmen[repairmanID].categories, category]
																			})
																	}}
																/>
															</div>
														), categories)
													}
												</div>
											</div>

											:<div style={{marginLeft: "0px"}}>
												{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
													<p
														style={{
															fontSize: "12px"
														  , color: "#808080"
														  , display: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" : "block"
														}}
													>
														Category
													</p>
													:
													<p
														style={{
													 		marginTop: "8px"
														  , marginBottom: "0"
														  , fontSize: "14px"
														}}
													>
														{R.values(
															R.mapObjIndexed((category, indx) => (
																	<span key={indx} style={{marginRight: '5px'}}>
																		{category}
																		{(this.props.repairmen[repairmanID].categories.length - 1 == indx)? ".": ", "}
																	</span>
															), this.props.repairmen[repairmanID].categories)
														)}
													</p>
												}
											</div>
										}
									</div>
								</div>
								<div
									className="contacts logical-block"
									style={{
										paddingBottom: (isMob)?"8px":"19px"
									}}
								>
									{
										(this.state.editing == "contacts")?
												<img src="/manager/static/img/ok.png"
													style={{
														 float: "right"
													  , height: "20px"
													  , lineHeight: "35px"
													  , cursor: "pointer"
													}}
													onClick={()=> this.setState({editing: "none"})}
												/>
											:
												<img
													src="../static/img/pencil-edit.png"
													style={{
														float: "right"
													  , height: "20px"
													  , margin: "0"
													  , cursor: "pointer"
													}}
													onClick={()=> this.setState({editing: "contacts"})}
												/>
									}
									<p
										style={{
											fontSize: (this.state.editing ==  "contacts")?"16px":"9pt"
										  , color: (this.state.editing ==  "contacts")?"#000":"#909090"
										  , margin: "0"
										  , marginBottom: "11px"
										}}
									>
										Contacts
									</p>
									{(this.state.editing ==  "contacts")?
										<div>
											<div style={{
													width: (typeof global.md.phone() != 'string')? "370px" : "100%"
												}}
											>
												<p
													style={{
														marginTop: "24px"
													  , marginLeft:  "0px"
													  , color: "#929292"
													  , fontSize: "11px"
													  , marginBottom: "0px"
													}}
												>
													Cell number
												</p>
												<InputPhone
													value={this.props.repairmen[repairmanID].cellNumber || ""}
													onBlur={(newValue)=> this.props.DOC_UPDATE({_id: repairmanID, cellNumber: newValue})}
													inputStyle={{fontSize: "14px"}}
												/>
											</div>

											<div style={{
													width: (typeof global.md.phone() != 'string')? "370px" : "100%"
												}}
											>
												<p
													style={{
														marginTop: "16px"
													  , marginLeft:  "0px"
													  , color: "#929292"
													  , fontSize: "11px"
													  , marginBottom: "0px"
													}}
												>
													Office number
												</p>
												<InputPhone
													value={this.props.repairmen[repairmanID].phoneNumber || ""}
													onBlur={(newValue)=> this.props.DOC_UPDATE({_id: repairmanID, phoneNumber: newValue})}
													inputStyle={{fontSize: "14px"}}
												/>
											</div>

											<div style={{
													width: (typeof global.md.phone() != 'string')? "370px" : "100%"
												}}
											>
												<p
													style={{
														marginTop: "16px"
													  , marginLeft:  "0px"
													  , color: "#929292"
													  , fontSize: "11px"
													  , marginBottom: "0px"
													}}
												>
													Home number
												</p>
												<InputPhone
													value={this.props.repairmen[repairmanID].homeNumber || ""}
													onBlur={(newValue)=> this.props.DOC_UPDATE({_id: repairmanID, homeNumber: newValue})}
													inputStyle={{fontSize: "14px"}}
												/>
											</div>

											<div style={{
													width: (typeof global.md.phone() != 'string')? "370px" : "100%"
												}}
											>
												<p
													style={{
														marginTop: "16px"
													  , marginLeft:  "0px"
													  , color: "#929292"
													  , fontSize: "11px"
													  , marginBottom: "0px"
													}}
												>
													Fax number
												</p>
												<InputPhone
													value={this.props.repairmen[repairmanID].faxNumber || ""}
													onBlur={(newValue)=> this.props.DOC_UPDATE({_id: repairmanID, faxNumber: newValue})}
													inputStyle={{fontSize: "14px"}}
												/>
											</div>

											<div style={{
													width: (typeof global.md.phone() != 'string')? "370px" : "100%"
												}}
											>
												<p
													style={{
														marginTop: "16px"
													  , marginLeft:  "0px"
													  , color: "#929292"
													  , fontSize: "11px"
													  , marginBottom: "0px"
													}}
												>
													Email
												</p>
												<TextField
													fullWidth={true}
													defaultValue={this.props.repairmen[repairmanID].email || ""}
													onBlur={(evt)=> this.props.DOC_UPDATE({_id: repairmanID, email: evt.target.value})}
													inputStyle={{fontSize: "14px"}}
												/>
											</div>

											<div style={{
													width: (typeof global.md.phone() != 'string')? "370px" : "100%"
												}}
											>
												<p
													style={{
														marginTop: "16px"
													  , marginLeft:  "0px"
													  , color: "#929292"
													  , fontSize: "11px"
													  , marginBottom: "0px"
													}}
												>
													Web
												</p>
												<TextField
													defaultValue={this.props.repairmen[repairmanID].web || ""}
													onBlur={(evt)=> this.props.DOC_UPDATE({_id: repairmanID, web: evt.target.value})}
													inputStyle={{fontSize: "14px"}}
													fullWidth={true}
												/>
											</div>

											<div style={{
													width: (typeof global.md.phone() != 'string')? "370px" : "100%"
												}}
											>
												<p
													style={{
														marginTop: "16px"
													  , marginLeft:  "0px"
													  , color: "#929292"
													  , fontSize: "11px"
													  , marginBottom: "0px"
													}}
												>
													Address
												</p>
												<TextField
													defaultValue={this.props.repairmen[repairmanID].address || ""}
													onBlur={(evt)=> {
													this.props.DOC_UPDATE({_id: repairmanID, address: evt.target.value, cors: {}})}
													}
													multiLine={true}
													fullWidth={true}
													inputStyle={{fontSize: "14px"}}
												/>
												<p
													style={{
														marginTop: "16px"
													  , marginLeft:  "0px"
													  , color: "#929292"
													  , fontSize: "11px"
													  , marginBottom: "0px"
													}}
												>
													Account#
												</p>
												<TextField
													defaultValue={this.props.repairmen[repairmanID].accountNumber || ""}
													onBlur={(evt)=> {
													this.props.DOC_UPDATE({_id: repairmanID, accountNumber: evt.target.value})}
													}
													fullWidth={true}
													inputStyle={{fontSize: "14px"}}
												/>
											</div>


										</div>
										:
										<div>
											<div style={(isMob)?
											{marginBottom: "4px"}:{MozColumnCount: "2", columnCount: "2", width: "25em"}
											}>
												<div style={{
														display: (!(this.props.repairmen[repairmanID].cellNumber && this.props.repairmen[repairmanID].cellNumber.length))?"none":(typeof global.md.phone() != 'string')? "inline-block" : "block"
														, position: "relative"
														, left: "3px"
													}}
													className="contact-row"
												>
														<p title="Cell">
															<svg
																width="10px"
																height="19px"
																viewBox="0 0 10 19"
																version="1.1"
																xmlns="http://www.w3.org/2000/svg"
																xmlnsXlink="http://www.w3.org/1999/xlink"
																style={{
																}}
															>
																<defs></defs>
																<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																	<g id="noun_192573_cc" fill="#3cd2ae">
																		<path
																			d="M9,4 L1,4 L1,15 L9,15 L9,4 L9,4 Z M7,2 L3,2 L3,3 L7,3 L7,2 L7,2 Z M5,18 C5.55,18 6,17.55 6,17 C6,16.45 5.55,16 5,16 C4.45,16 4,16.45 4,17 C4,17.55 4.45,18 5,18 L5,18 Z M8,19 L2,19 C0.9,19 0,17.93125 0,16.625 L0,2.375 C0,1.06875 0.9,0 2,0 L8,0 C9.1,0 10,1.06875 10,2.375 L10,16.625 C10,17.93125 9.1,19 8,19 L8,19 Z"
																			id="Shape"
																		>

																		</path>
																	</g>
																</g>
															</svg>
															<span
																style={{
																	fontSize: "14px"
																  , paddingLeft: "8px"
																}}
															>
																{` ${(this.props.repairmen[repairmanID].cellNumber)?this.props.repairmen[repairmanID].cellNumber:""}`}
															</span>
														</p>
												</div>

												<div style={{
														display: (!(this.props.repairmen[repairmanID].phoneNumber && this.props.repairmen[repairmanID].phoneNumber.length))?"none":(typeof global.md.phone() != 'string')? 'inline-block' : "block"
													  , marginTop: (isMob)?"20px":"0px"
													}}
													className="contact-row"
												>
													<p>
														<i
															className="material-icons"
															style={{
																marginLeft: (typeof global.md.phone() != 'string')? "10px" : "0"
																, marginTop: (typeof global.md.phone() != 'string')? "14px" : "0"
																, color: "#3cd2ae"
															}}
														>
															 call
														</i>
														<span
															style={{
																fontSize: "14px"
															}}
														>
															 {` ${(this.props.repairmen[repairmanID].phoneNumber)?this.props.repairmen[repairmanID].phoneNumber:''}`}
														</span>
													</p>
												</div>

												<div style={{
														display: (!(this.props.repairmen[repairmanID].homeNumber && this.props.repairmen[repairmanID].homeNumber.length))?"none":(typeof global.md.phone() != 'string')? 'inline-block' : "block"
													  , marginTop: (isMob)?"20px":"0px"
													}}
													className="contact-row"
												>
													<p>
														<i
															className="material-icons"
															style={{
																marginLeft: (typeof global.md.phone() != 'string')? "10px" : "0"
																, marginTop: (typeof global.md.phone() != 'string')? "14px" : "0"
																, color: "#3cd2ae"
															}}
														>
															 call
														</i>
														<span
															style={{
																fontSize: "14px"
															}}
														>
															{` ${this.props.repairmen[repairmanID].homeNumber}`}
														</span>
													</p>
												</div>

												<div style={{
														display: (!(this.props.repairmen[repairmanID].faxNumber && this.props.repairmen[repairmanID].faxNumber.length))?"none":(typeof global.md.phone() != 'string')? 'inline-block' : "block"
													  , marginTop: (isMob)?"20px":"0px"
													}}
													className="contact-row"
												>
													<p>
														<svg
															width="23px"
															height="13px"
															viewBox="0 0 32 13"
															version="1.1"
															xmlns="http://www.w3.org/2000/svg"
															xmlnsXlink="http://www.w3.org/1999/xlink"
															style={{
																marginLeft: (typeof global.md.phone() != 'string')? "10px" : ""
															  , marginTop: "5px"
															  , position: "relative"
															  , left: "-8px"
															}}
														>
															<title>FAX</title>
															<defs></defs>
															<g id="Page-1"
																stroke="none"
																strokeWidth="1"
																fill="none"
																fillRule="evenodd"
																fontWeight="normal"
																fontFamily="RobotoCondensed-Italic, Roboto Condensed"
																letterSpacing="-0.847058833"
																fontSize="14"
																fontStyle="italic"
															>
																<text
																	id="FAX"
																	fill="#3cd2ae"
																>
																	<tspan
																		x="1"
																		y="13"
																		style={{
																			fontStyle: "italic"
																		}}
																	>
																		FAX
																	</tspan>
																</text>
															</g>
														</svg>
														<span
															style={{
																fontSize: "14px"
															  , position: "relative"
  															  , left: "-8px"
															}}
														>
															{` ${this.props.repairmen[repairmanID].faxNumber}`}
														</span>
													</p>
												</div>

												<div style={{
														display: (!(this.props.repairmen[repairmanID].email && this.props.repairmen[repairmanID].email.length))?"none":(typeof global.md.phone() != 'string')? 'inline-block' : "block"
													  , marginTop: (isMob)?"20px":"0px"
													}}
													className="contact-row"
												>
													<p>
														<i
															className="material-icons"
															style={{
																marginLeft: (typeof global.md.phone() != 'string')? "10px" : "0"
																, marginTop: "14px"
																, color: "#3cd2ae"
																, marginRight: "6px"
															}}
														>
															email
														</i>
														<span
															style={{
																fontSize: "14px"
															  , marginLeft: "8px"
															}}
														>
															{` ${this.props.repairmen[repairmanID].email}`}
														</span>
													</p>
												</div>

												<div style={{
														display: (!(this.props.repairmen[repairmanID].web && this.props.repairmen[repairmanID].web.length))?"none":(typeof global.md.phone() != 'string')? 'inline-block' : "block"
													  , marginTop: (isMob)?"20px":"0px"
													}}
													className="contact-row"
												>
													<p>
														<i
															className="material-icons"
															style={{
																marginLeft: (typeof global.md.phone() != 'string')? "10px" : "0"
																, marginTop: "14px"
																, color: "#3cd2ae"
																, marginRight: "6px"
															}}
														>
															forward
														</i>
														<span
															style={{
																fontSize: "14px"
															  , marginLeft: "8px"
															}}
														>
															{` ${this.props.repairmen[repairmanID].web}`}
														</span>
													</p>
												</div>
											</div>
										<div
											style={{
												display: (!(this.props.repairmen[repairmanID].address && this.props.repairmen[repairmanID].address.length))?"none":(typeof global.md.phone() != 'string')? 'inline-block' : "block"
											  , marginTop: (isMob)?"":"-8px"
											}}
										>
											<p>
												<i
													className="material-icons"
													style={{
														color: "#3cd2ae"
													  , verticalAlign: (typeof global.md.phone() != 'string')? "auto" : "middle"
													  , fontSize: "18px"
													  , position: "relative"
													  , top: "2px"
													}}
												>
													location_on
												</i>
												<span
													style={{
														fontSize: "14px"
													}}
												>
													{` ${this.props.repairmen[repairmanID].address}`}
												</span>
											</p>
										</div>
									</div>
									}
								</div>
								<div className="tasks logical-block">
									{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
										<img
											src="/static/img/plus-green.png"
											style={{
												float: "right"
											  , width: "20px"
											  , margin: "0"
											  , marginTop: "-3pt"
											  , marginRight: "3pt"
											  , cursor: "pointer"
											}}
											onClick={()=>
												this.props.history.push({
													pathname: `/manager/tasks`,
													state: { refRepMan: repairmanID }
												})
											}
										/>
										:""
									}
									<div
										style={{
											marginTop: "-15px"
										}}
									>
										<p
											style={{
												fontSize: "9pt"
											  , fontWeight: "100"
											  , color: "#909090"
											  , margin: "0"
											  , marginBottom: "11px"
											}}
										>
											<span
												style={{
													verticalAlign: "middle"
												}}
											>
												Tasks
											</span>
											{(typeof global.md.phone() != "string")?
												<svg
													width="24px"
													height="24px"
													viewBox="0 0 24 24"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
													xmlnsXlink="http://www.w3.org/1999/xlink"
													onClick={()=>
														this.props.history.push({
															pathname: `/manager/tasks`,
															state: { refRepMan: repairmanID }
														})
													}
													style={{
														verticalAlign: "middle"
													  , marginLeft: "7px"
													  , cursor: "pointer"
													}}
												>
													    <title>Group 2</title>
													    <defs></defs>
													    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
													        <g id="Group-2" transform="translate(1.000000, 1.000000)" stroke="#5ae4c3" strokeWidth="2">
													            <path d="M11,4.5 L11,17.5" id="Line" stroke-linecap="square"></path>
													            <path d="M5,11 L17,11" id="Line" stroke-linecap="square"></path>
													            <circle id="Oval-1" cx="11" cy="11" r="11"></circle>
													        </g>
													    </g>
												</svg>
												: ""
											}


										</p>
										<div
											className="buttons-wrapper"
										>
											<div
												className={`button-task ${(!this.state.completed)? "active" : ""}`}
												onClick={()=> this.setState({completed: false})}
												style={{
													width: "50%"
												}}
											>
												<span style={{fontSize: (isMob)?"12px":"auto"}}>
													ACTIVE ({(this.props.repairmen[repairmanID].tasksActive)? this.props.repairmen[repairmanID].tasksActive.length : 0})
												</span>
											</div>
											<div
												className={`button-task ${(this.state.completed)? "active" : ""}`}
												onClick={()=> this.setState({completed: true})}
												style={{
													width: "50%"
												}}
											>
												<span style={{fontSize: (isMob)?"12px":"auto"}}>
													COMPLETED ({(this.props.repairmen[repairmanID].tasksDone)? this.props.repairmen[repairmanID].tasksDone.length : 0})
												</span>
											</div>
										</div>
										<List>
											{(
												(this.state.completed && (!this.props.repairmen[repairmanID].tasksDone || !this.props.repairmen[repairmanID].tasksDone.length))
												||
												(!this.state.completed && (!this.props.repairmen[repairmanID].tasksActive || !this.props.repairmen[repairmanID].tasksActive.length))
											)?
												<ListItem
													style={{
														height: "45px"
													}}
													disabled={true}
													primaryText="None"
												/>
												:
												R.map(task => (
													<Link
														to={`/manager/task/${task._id}`}
														style={{
															textDecoration: 'none'
														}}
														key={task._id}
													>
														<div
															style={{
																overflow: "hidden"
															}}
														>
															<img
																src="/static/img/arrow_right.png"
																style={{
																	float: "right"
																  , marginTop: "7pt"
																  , marginRight: "5pt"
																  , height: "20pt"
																}}
															/>
															<ListItem
																style={{
																	height: "45px"
																}}
																primaryText={task.taskContent}
															/>
														</div>
														<Divider />
													</Link>
												), (this.state.completed)? this.props.repairmen[repairmanID].tasksDone : this.props.repairmen[repairmanID].tasksActive)
											}
										</List>
									</div>
								</div>
									<div className="attachments logical-block" style={{marginLeft: "20px", marginTop: "16px"}}>
										<Attachments objectID={repairmanID} path={this.props.path} removable={true}/>
									</div>
							</div>
						</Tab>
						<Tab
							label={
								<span>Comments (
									{(this.props.repairmen[repairmanID].comments)? R.filter(comment => !comment.auto && comment.body, this.props.repairmen[repairmanID].comments).length:"0"}
								)
								</span>
							}
						>
							<div
								style={{
										maxWidth: (this.props.id)? 'auto' : '800px'
									  , margin: "auto"
									  , marginTop: "0px"
									  , overflow: (typeof global.global.md.phone() == "string" || (typeof global.global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "auto" : 'hidden'
									  , height: (typeof global.global.md.phone() == 'string')? "100vh" : "calc(100vh - 97px)"
									  , paddingRight: "0px"
								}}
								speed={0.8}
								className="area"
								contentClassName="content"
								horizontal={false}
								verticalScrollbarStyle={{
									width: "16px"
								  , borderRadius: "13px"
								  , marginLeft: "1px"
								  , backgroundImage: "url(/static/img/bar.png)"
								  , backgroundSize: "100%"
								  , backgroundRepeat: "no-repeat"
								  , backgroundColor: "#f5f6f5"
								  , backgroundPosition: "center"
								  , display: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" :"auto"
								}}
								minScrollSize={30}
								verticalContainerStyle={{
									width: "18px"
								  , backgroundColor: "#cdcdcd"
								  , opacity: "1"
								  , display: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" :"auto"
								}}
								ref="right-panel"
								className={(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "mobile-right-panel": ""}
							>
								<Comments objectID={repairmanID} path={this.props.path} />
							</div>
						</Tab>
					</Tabs>
					}

				</div>
					}
				</div>
			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}
}

export default connect(select, R.mergeAll([dataActions, attachmentOverlayActions, routerActions, rightStackActions, newCommentActions, actionBarActions]))(Repairman)



// WEBPACK FOOTER //
// ./src/routes/manager/repairmanForm/index.js